import React, { useState } from 'react';
import { Modal, Button, FormField, Box, Grid, Container } from '@cloudscape-design/components';
import Calendar from "@cloudscape-design/components/calendar";
interface DatePickerModalProps {
    visible: boolean;
    close?: boolean;
    clear?: boolean;
    today?: boolean;
    start?: Date;
    end?: Date;
    title?: string;
    subTitle?: string;
    onDismiss: () => void;
    onConfirm: (selectedDate: string) => void;
}
const DatePickerModal: React.FC<DatePickerModalProps> = ({
    visible,
    close = false,
    clear = true,
    today = false,
    start = undefined,
    end = undefined,
    title='Seleccione',
    subTitle='Fecha',
    onDismiss,
    onConfirm,
}) => {
    const [selectedDate, setSelectedDate] = useState<string>('');
    const handleDateChange = ({ detail }: { detail: { value: string } }) => {
        setSelectedDate(detail.value);
        onConfirm(detail.value);
        onDismiss();
    };
    const dateClear = () => {
        setSelectedDate('')
        onConfirm('');
    }
    const dateToday = () => {
        let today=new Date();
        const normalizedStart = new Date(today.getFullYear(), today.getMonth(), today.getDate())    
        const formatted = normalizedStart.toISOString().slice(0, 10);
        setSelectedDate(formatted)
        onConfirm(formatted);
    }
    const normalizedStart = start ? new Date(start.getFullYear(), start.getMonth(), start.getDate()) : undefined;
    const normalizedEnd = end ? new Date(end.getFullYear(), end.getMonth(), end.getDate()) : undefined;
    const isDateInRange = (date: Date) => {
        const d = new Date(date.getFullYear(), date.getMonth(), date.getDate());
        if (normalizedStart && normalizedEnd) return d >= normalizedStart && d <= normalizedEnd;
        if (normalizedStart) return d >= normalizedStart;
        if (normalizedEnd) return d <= normalizedEnd;
        return true;
    };
    const normalizeDate = (d: Date) => {
        return new Date(d.getFullYear(), d.getMonth(), d.getDate());
    };
    return (
        <Modal
            visible={visible}
            onDismiss={onDismiss}
            size="small"
            header={title}
            footer={
                <Grid
                    gridDefinition={[
                        { colspan: 6 },
                        { colspan: 6 },
                    ]}
                >
                    {close && (
                        <Button variant="link" onClick={onDismiss}>Cerrar</Button>
                    )}
                    {today && (
                        <Button variant="primary" onClick={dateToday}>Hoy</Button>
                    )}
                    <Box textAlign="right">
                        {clear && (
                            <Button variant="primary" onClick={dateClear}>Limpiar</Button>
                        )}
                    </Box>
                </Grid>
            }
        >
            <FormField label={subTitle} stretch>
                <Container>
                <Calendar
                    value={selectedDate}
                    onChange={handleDateChange}
                    locale="es-CL"
                    startOfWeek={1}
                    isDateEnabled={isDateInRange}
                />
                </Container>
            </FormField>
        </Modal >
    );
};

export default DatePickerModal;